import React from "react"

type TabProps = {
  activeTab: string
  setActiveTab: (tab: string) => void
}

const StoreTabControl: React.FC<TabProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex border-b border-gray-200 mb-4 -mt-0.5">
      <button
        className={`py-2 px-4 font-medium ${
          activeTab === "pos" ? "border-b-2 border-green-700 text-green-700" : "text-gray-500 hover:text-gray-700"
        }`}
        onClick={() => setActiveTab("pos")}
      >
        Point of Sale
      </button>
      <button
        className={`py-2 px-4 font-medium ${
          activeTab === "history" ? "border-b-2 border-green-700 text-green-700" : "text-gray-500 hover:text-gray-700"
        }`}
        onClick={() => setActiveTab("history")}
      >
        Transaction History
      </button>
    </div>
  )
}

export default StoreTabControl
